<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>投诉列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">理由：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入理由" disabled style="width:400px;" max-l v-model="subData.reason"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">说明：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入说明" disabled style="width:400px;" max-l v-model="subData.remark"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">截图：</el-text>
			<el-col :span="4">
        		<img :src="iItem" style="height: 40px; width:40px; margin:5px; float:left;" @click="showBig(iItem)" v-for="iItem in subData.imgList" />
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">投诉日期：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.addDate" disabled type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">审核结果：</el-text>
			<el-col :span="4">
				<el-radio label="通过" v-model="submitData.state"></el-radio>
				<el-radio label="失败" v-model="submitData.state"></el-radio>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">结果：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入结果" style="width:400px;" v-model="submitData.result"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		userId : '',
		touUserId : '',
		reason : '',
		remark : '',
		imgs : '',
		addDate : '',
		state : '',
		updateDate : '',
		result : '',
      },
	  submitData:{
		state: '',
		result:''
	  }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/Tousus/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
			ths.subData.imgList = [];
			if(ths.subData.imgs){
				ths.subData.imgList = ths.subData.imgs.split(",");
			}
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;
	  var data = {
		id : ths.id,
		state: ths.submitData.state,
		result: ths.submitData.result
	  }
	  if(data.state == '通过'){
		data.state = 2;
	  }else if(data.state == '失败'){
		data.state = 3;
	  }
	  if(!data.state){
		alert("请选择审核结果");
		return;
	  }
      ths.$post('/Tousus/apply?', data)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/ToususList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>